import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})

export class BlogService {
    constructor(private http: HttpClient) {
    }

    getPublishedBlogPosts() {
        return this.http.get('/agri/getPublishedPosts');
    }

    // Filter Contracts
    listPublishedBlogPosts(size, page, sort, orderDir, filterData: object) {
        return this.http.post('agri/listBlogFiltered?page=' + (page - 1) + '&size=' + size + '&sort=' + sort + '&dir=' + orderDir, filterData);
    }
}
